const { getElement, getElements } = window.BAO.Utils
export class GuidesIndex extends window.BAO.CustomElement() {
  constructor () {
    super()

    // States
    this.allGuidesLoaded = this.dataset.allGuidesLoaded === 'true'

    // Elements
    this.guidesList = getElement('[data-guides-index-el="guideList"]')
    this.guides = getElements('[data-guides-index-el="guide"]')
    this.search = getElement('[data-guides-index-el="search"]')
    this.loadMore = getElement('[data-guides-index-el="loadMore"]')
    this.loadMoreButton = getElement('[data-guides-index-el="loadMoreButton"]')
    this.noResults = getElement('[data-guides-index-el="noResults"]')

    // Data
    this.guidesData = this.dataset.guides && JSON.parse(this.dataset.guides)
  }

  setupListeners () {
    super.setupListeners()

    // Search
    this.listeners.add(this.search, 'input', this.handleSearch.bind(this))

    // If all Guides are loaded via Liquid on load, the Load More button will not be present
    if (this.loadMore && this.loadMoreButton) {
      this.listeners.add(this.loadMoreButton, 'click', this.loadRemainingGuides.bind(this))
    }
  }

  handleSearch () {
    if (this.allGuidesLoaded !== true) this.loadRemainingGuides()

    let resultsCount = 0
    const searchTerm = this.search.value?.toLowerCase().replace(' ', '')

    this.guides.forEach(guide => {
      const guideTitle = guide.dataset.title?.toLowerCase().replace(' ', '')
      if (guideTitle.includes(searchTerm)) {
        guide.removeAttribute('data-mobile-filtered')
        resultsCount++
      } else {
        guide.setAttribute('data-mobile-filtered', true)
      }
    })

    // Toggle No Results element
    if (resultsCount === 0) {
      this.noResults.removeAttribute('aria-hidden')
    } else {
      this.noResults.setAttribute('aria-hidden', true)
    }
  }

  loadRemainingGuides () {
    if (this.allGuidesLoaded === true || !this.loadMore || !this.loadMoreButton) return

    // Load remaining guides
    this.guidesData.forEach(guideData => {
      if (!guideData.title || !guideData.icon || !guideData.url) return
      const guideMarkup = this.guideMarkup(guideData)
      this.guidesList.insertAdjacentHTML('beforeend', guideMarkup)
    })

    // Hide Load More button
    this.loadMore.setAttribute('aria-hidden', true)

    // Update state
    this.allGuidesLoaded = true

    // Update guides list
    this.guides = getElements('[data-guides-index-el="guide"]')
  }

  guideMarkup (guideData) {
    return `
      <li
        class="pg-GuidesIndex_Guide util-FauxLink"
        data-guides-index-el="guide"
        data-title="${guideData.title.toLowerCase()}"
      >
        <img src="${guideData.icon}" alt="${guideData.title}" width="250" class="pg-GuidesIndex_GuideImage">
        <h3 class="pg-GuidesIndex_GuideTitle fz-12_110">${guideData.title}</h3>
        <a class="util-FauxLink_Link" href="${guideData.url}">
          <span class="util-ScreenReaderOnly">${guideData.title}</span>
        </a>
      </li>
    `
  }
}

if (!customElements.get('guides-index')) {
  customElements.define('guides-index', GuidesIndex)
}
